import ListPeople from "./ListPeople";

export default ListPeople;
